import { useLoadingUiState } from "@/states/loading/selectors";

export default function GlobalLoading() {
  const state = useLoadingUiState();

  if (state.status === "Loading") {
    return (
      <div className="fixed top-0 left-0 w-full h-full z-max bg-black/50">
        <div
          className="flex justify-center items-center w-full h-full z-max"
          style={{ marginTop: "-50px" }}
        >
          <div className="py-8 text-center flex flex-col items-center justify-center border-2 w-full align-middle bg-white transition-all max-w-[230px] rounded-lg opacity-100 scale-100">
            <div className="z-max w-28 h-28 rounded-full border-4 border-gray-300 border-t-transparent animate-spin"></div>
            <p className="pt-5">{'読み込み中'}</p>
            {state.customText && <p className="pt-1 px-1">{state.customText}</p>}
          </div>
        </div>
      </div>
    );
  }

  return <></>;
}
